import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InscricaoService } from '../../../shared/service/inscricao/inscricao.service';
import * as _ from 'lodash';
import { TipoSituacao } from '../../../shared/models/inscricao/tipo-situacao.model';
import { AuthService } from '@sicapes/auth';
import { ParametrizacaoService } from '../../../shared/service/parametrizacao/parametrizacao.service';
import { Message } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import {RegraIniciarInscricao} from "../../../shared/service/inscricao/regra-iniciar-inscricao";
import { RecursoService } from 'src/app/shared/service/inscricao/recurso.service';
import { LocalStorageService } from 'src/app/shared/service/local-storage.service';
import * as moment from 'moment';
@Component({
    selector: 'app-dashboard-painel',
    templateUrl: './dashboard-painel.component.html',
    styleUrls: ['./dashboard-painel.component.less']
})
export class DashboardPainelComponent implements OnInit {

    tipo = '';
    qtdeAberta: number = 0;
    qtdeEmPreenchimento: number = 0;
    qtdeFinalizada: number = 0;
    qtdeCancelada: number = 0;
    qtdeCanceladaExpirado: number = 0;
    qtdeEmRecurso: number = 0;
    qtdeEmAnalise: number = 0;
    qtdeAnalisada: number = 0;
    qtdeRecursoExpirado: number = 0;
    qtdeRecursoEncaminhado: number = 0;
    qtdeMinhasInscricoes: number = 0;
    tabInscricoesAbertas: boolean = true;
    tabMinhasInscricoes: boolean = false;
    tabMinhasReconsideracoes: boolean = false;

    hasExecutouObterRecurso: boolean = false;

    parametrizacoes: any = [];
    dashboardMessages: Message[] = [];
    dashboardNavExecution: boolean = false;
    exibirMensagem: boolean = false;
    mensagem: string = '';
    siglaEditalRedirecionamento: string = '';

    inscricoes: any = {
        emPreenchimento: [],
        finalizada: [],
        emAnalise: [],
        analisada: [],
        cancelada: [],
        canceladaExpirada: [],
        recurso: [],
    };

    reconsideracoes: any =
        {
            quantidade: 0,
            ocorrencias: [],
            inscricoes: []
        }

    arrTipoSituacao: any[] = [];

    cdInscricaoExpandir = '';
    cacheTTL = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

    constructor(private authService: AuthService,
        private inscricaoService: InscricaoService,
        private parametrizacaoService: ParametrizacaoService,
        protected toastr: ToastrService,
        protected route: ActivatedRoute,
        protected router: Router,
        private dashboardService: DashboardService,
        private elRef: ElementRef,
        private recursoService: RecursoService,
        private regraIniciarInscricao: RegraIniciarInscricao,
        private localStorageService: LocalStorageService
    ) {
        this.arrTipoSituacao['recurso'] = [{ descricao: 'recurso' }];
        this.arrTipoSituacao['em-preenchimento'] = [{ descricao: 'em-preenchimento' }];
        this.arrTipoSituacao['finalizada'] = [{ descricao: 'finalizada' }];
        this.arrTipoSituacao['em-analise'] = [{ descricao: 'em-analise' }, { descricao: 'analisada' }];
        this.arrTipoSituacao['cancelada'] = [{ descricao: 'cancelada' }, { descricao: 'cancelada-expirada' }];

    }

    ngOnInit(): void {
        if (this.localStorageService.get('siglaEdital') !== null && this.localStorageService.get('siglaEdital') !== undefined && this.localStorageService.get('siglaEdital') !== '' && this.localStorageService.get('siglaEdital') !== 'null' && this.localStorageService.get('siglaEdital') !== 'undefined' && this.localStorageService.get('siglaEdital').length > 3) {
            this.siglaEditalRedirecionamento = this.localStorageService.get('siglaEdital');
            this.redirecionarParaInscricao();
        } 
        else {
            this.inscricaoService.getQtdeInscricoesSituacao().subscribe(
                (resources: any) => {
                    this.bindDataResourcesQtde(resources);
                    this.obterParametrizacoesAtiva();
                },
                (error: any) => this.toastr.error('Não foi possivel recuperar informações das inscrições.')
            );
        }

        // TODO: O QUE GERE O SIMULADOR DE ACESSO NÃO PODE FICAR EM CADA COMPONENTE, DEVE SER ALGUM INTERCEPTOR QUE DEVE GERENCIAR
        this.authService.currentUser.subscribe((x: any) => {
            if (('corporativo' in x) &&
                ('pessoaLogada' in x) &&
                x.corporativo.codigo !== x.pessoaLogada.codigo) {
                this.recursoService.simuladorAcesso = btoa(x.corporativo.codigo);
            } else {
                this.recursoService.simuladorAcesso = null;
            }
            this.recursoService.obterReconsideracoes().subscribe((response) => {
                this.trataReconsideracoes(response);
            },
                (err) => {
                    console.error("erro ao obter reconsideracoes");
                },
                () => { }
            );
        });
    }

    private carregarDashboard(): void {
        this.inscricaoService.getQtdeInscricoesSituacao().subscribe(
            (resources: any) => {
                this.bindDataResourcesQtde(resources);
                this.obterParametrizacoesAtiva();
            },
            (error: any) => this.toastr.error('Não foi possivel recuperar informações das inscrições.')
        );
    }

    private trataReconsideracoes = (reconsideracoes): void => {
        if (reconsideracoes.total_items > 0) {
            this.reconsideracoes.quantidade = reconsideracoes._embedded.itens.length
            this.reconsideracoes.ocorrencias = reconsideracoes._embedded.itens.filter(r => { return !(r.reconsideracaoOcorrencia == null); })
            this.reconsideracoes.inscricoes = reconsideracoes._embedded.itens.filter(r => { return !(r.inscricao == null); })
        }
    }

    public obterParametrizacoesAtiva(): void {
        const proponente = this.authService.getUsuario();
        this.parametrizacaoService.obterParametrizacoesAtiva(proponente.id).subscribe(
            (r: any) => {
                this.parametrizacoes = r;
                this.qtdeAberta = r.length;
            },
            (e: any) => this.toastr.error('Não foi possivel recuperar as parametrizações ativas.')
        );
    }

    public reciverInscricao(cdInscricao: string): void {
        this.cdInscricaoExpandir = cdInscricao;
        this.ngOnInit();
    }

    public handleChange(tipo: any): void {

        this.tipo = tipo;

        if (this.tipo !== '') {

            for (const situacao of this.arrTipoSituacao[tipo]) {

                // se a variavel existir, desnecessario executar novamente o rest
                if (this.inscricoes[_.camelCase(situacao.descricao)] !== undefined && this.inscricoes[_.camelCase(situacao.descricao)].length > 0) {
                    this.inscricoes[_.camelCase(situacao.descricao)] = undefined;
                    return;
                }

                this.getInscricoesPorSituacoes(situacao);

            }
        }

    }

    public getInscricoesPorSituacoes(situacao: TipoSituacao): void {
        this.inscricaoService.getInscricoesSituacao(situacao).subscribe(
            (resources: any) => {
                if (typeof this.inscricoes === 'undefined') {
                    this.inscricoes = {};
                }
                if(situacao.descricao === 'em-preenchimento') {
                    this.localStorageService.set('inscricoes-em-preenchimento', resources);
                }
                this.inscricoes[_.camelCase(situacao.descricao)] = resources;
            },
            (error: any) => this.toastr.error('Não foi possivel recuperar as situações da inscrição.')
        );
    }

    public bindDataResourcesQtde(resources: any): void {
        const rows: any[] = resources._embedded.items;

        this.qtdeEmPreenchimento = (rows.filter(this.generateSituacaoComparator('Em preenchimento')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Em preenchimento'))[0].qtde) : 0;
        this.qtdeFinalizada = (rows.filter(this.generateSituacaoComparator('Finalizada')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Finalizada'))[0].qtde) : 0;
        this.qtdeCancelada = (rows.filter(this.generateSituacaoComparator('Cancelada')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Cancelada'))[0].qtde) : 0;
        this.qtdeCanceladaExpirado = (rows.filter(this.generateSituacaoComparator('Cancelada - Prazo de Inscrição Expirado')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Cancelada - Prazo de Inscrição Expirado'))[0].qtde) : 0;
        this.qtdeCancelada = this.qtdeCancelada + this.qtdeCanceladaExpirado;
        this.qtdeEmRecurso = (rows.filter(this.generateSituacaoComparator('Recurso')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Recurso'))[0].qtde) : 0;
        this.qtdeEmAnalise = (rows.filter(this.generateSituacaoComparator('Em Análise')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Em Análise'))[0].qtde) : 0;
        this.qtdeRecursoExpirado = (rows.filter(this.generateSituacaoComparator('Recurso - Prazo Expirado')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Recurso - Prazo Expirado'))[0].qtde) : 0;
        this.qtdeRecursoEncaminhado = (rows.filter(this.generateSituacaoComparator('Recurso - Submetido')).length > 0) ? parseInt(rows.filter(this.generateSituacaoComparator('Recurso - Submetido'))[0].qtde) : 0;
        this.qtdeMinhasInscricoes = this.qtdeEmPreenchimento + this.qtdeFinalizada + this.qtdeCancelada + this.qtdeEmRecurso + this.qtdeEmAnalise + this.qtdeAnalisada;

        // Verifica se alguam inscricao está em recurso ou passou dela
        if (this.qtdeEmAnalise > 0 || this.qtdeEmRecurso > 0) {
            // this.getInscricoesEmRecurso();
        }
        // active a aba em preenchimento e executa o rest para trazer as inscriçoes em preenchimento.
        if (this.qtdeEmRecurso > 0) {
            this.getInscricoesPorSituacoes({ descricao: 'recurso' });
            this.dashboardMessages.push({ closable: true, severity: "warn", summary: "RECURSO", detail: "Há Proposta aguardando recurso", styleClass: 'aumenta-fonte' })
        }

        if (this.qtdeEmPreenchimento > 0) {
            this.getInscricoesPorSituacoes({ descricao: 'em-preenchimento' });
        }

        if (this.qtdeRecursoExpirado > 0) {
            this.getInscricoesPorSituacoes({ descricao: 'recurso-prazo-expirado' });
        }
        if (this.qtdeRecursoEncaminhado > 0) {
            this.getInscricoesPorSituacoes({ descricao: 'recurso-submetido' });
        }

        this.dashboardService.dadosCarregadosEvent.subscribe(e => {
            this.dashboardNavigation();
        })
    }

    private generateSituacaoComparator(situacao: string): any {
        return (inscricao: any) => inscricao.descricao === situacao;
    }
    public getInscricoesEmRecurso(): any {
        if ((this.qtdeEmAnalise > 0 || this.qtdeEmRecurso > 0) && !this.hasExecutouObterRecurso) {
            let proponente = this.authService.getUsuario();
            this.inscricaoService.getInscricoesParaRecurso(proponente.id).subscribe((resource: any) => {
                this.hasExecutouObterRecurso = true;
                if (resource._embedded.items.length > 0) {
                    this.ngOnInit();
                }
            }, () => { });
        }
    }
    private dashboardNavigation(): void {
        this.route.params.subscribe(params => {
            if (('aba' in params)) {
                this.tabMinhasInscricoes = (params.aba === 'minhas-inscricoes') ? true : false;
                this.tabInscricoesAbertas = !this.tabMinhasInscricoes;
            }

            if (('situacao' in params)) {
                if (this.inscricoes[_.camelCase(params.situacao)].length == 0 && !this.dashboardNavExecution) {
                    this.getInscricoesPorSituacoes({ descricao: params.situacao });
                    this.dashboardNavExecution = true;
                }


                if (this.elRef != null && this.elRef.nativeElement != null) {
                    const anchor = this.elRef.nativeElement.querySelector(
                        'a#inscricoes-' + params.situacao,
                    );
                    if (anchor != null) {
                        anchor.scrollIntoView();
                    }
                }
            }

        });
    }

    private redirecionarParaInscricao(): void {        
        if (typeof this.inscricoes === 'undefined') {
            this.inscricoes = {};
        }
        this.inscricoes = this.localStorageService.get('inscricoes-em-preenchimento');

        if(this.inscricoes === null || this.inscricoes === undefined || this.inscricoes.length === undefined) {
            this.obterInscricaoEmPreenchimento();
        } else {
            let inscricaoEmPreenchimento = this.inscricoes.filter((inscricao) => {
                return inscricao.sg_edital === this.siglaEditalRedirecionamento;
            })[0];

            this.executarRegrasIniciarInscricao(inscricaoEmPreenchimento);
        }
        this.localStorageService.set('siglaEdital', null);
    }

    private formatarDataParaPtBR(dataYYYYMMDD: any): string {
        let inputDateString = dataYYYYMMDD;
        let outputDateString = '';
        const momentObj = moment(inputDateString, 'YYYY-MM-DD');
        outputDateString = momentObj.format('DD/MM/YYYY');

        return outputDateString;
    }

    private obterInscricaoEmPreenchimento(): any {
        this.inscricaoService.getInscricoesSituacao({ descricao: 'em-preenchimento' }).subscribe(
            (resources: any) => {
                if (typeof this.inscricoes === 'undefined') {
                    this.inscricoes = {};
                }
                this.inscricoes = resources;
                let inscricaoEmPreenchimento = this.inscricoes.filter((inscricao) => {
                    return inscricao.sg_edital === this.siglaEditalRedirecionamento;
                })[0];

                this.executarRegrasIniciarInscricao(inscricaoEmPreenchimento)

            },
            (error: any) => this.toastr.error('Não foi possivel recuperar as situações da inscrição.')
        );
        this.localStorageService.set('siglaEdital', null);
    }

    private executarRegrasIniciarInscricao(inscricaoEmPreenchimento: any): void {
        if (typeof inscricaoEmPreenchimento !== 'undefined' && typeof inscricaoEmPreenchimento !== undefined) {
            this.localStorageService.set('siglaEdital', null);
            const dataAtual = moment(); // Data e hora de agora
            const dataFimInscricao = moment(inscricaoEmPreenchimento.dt_fim_fase); // Data e hora de fim de inscrição
            if(dataFimInscricao.isAfter(dataAtual)) {
                this.router.navigate([`/inscricao/${inscricaoEmPreenchimento.ds_identificador_registrado}/${inscricaoEmPreenchimento.cd_inscricao}/${inscricaoEmPreenchimento.formularios[0].sg_tipo_formulario}`]);    
            }
            else {
                this.exibirMensagem = true;
                this.mensagem = 'O período de inscrição do edital ' + this.siglaEditalRedirecionamento + ' expirou em ' + this.formatarDataParaPtBR(inscricaoEmPreenchimento.dt_fim_fase) + '.';
                this.toastr.info(this.mensagem,'Atenção!', {
                    timeOut: 6000
                });
                this.carregarDashboard();
            }
        } else if(typeof inscricaoEmPreenchimento === 'undefined' || typeof inscricaoEmPreenchimento === undefined) {
            const proponente = this.authService.getUsuario();
            this.parametrizacaoService.obterParametrizacoesAtiva(proponente.id).subscribe(
                async (r: any) => {
                    this.parametrizacoes = r;
                    this.qtdeAberta = r.length;
                    let parametrizacaoEdital = this.parametrizacoes.filter((p) => {
                        return p.sg_edital === this.siglaEditalRedirecionamento;
                    })[0];
                    if (typeof parametrizacaoEdital !== 'undefined' && typeof parametrizacaoEdital !== undefined) {
                        this.localStorageService.set('siglaEdital', null);
                        if(await this.regraIniciarInscricao.validateInscricaoStart(parametrizacaoEdital)) {
                            this.inscricaoService.iniciarInscricao(parametrizacaoEdital).subscribe(
                                (inscricao: any) => {
                                    const formulariosDadosPessoaisEsp: string[] = [
                                        'inscricao-dados-pessoais',
                                        'inscricao-dados-pessoais-brasileiros',
                                        'inscricao-dados-pessoais-completos',
                                        'inscricao-dados-pessoais-completos-dri',
                                        'inscricao-dados-pessoais-dpb',
                                        'inscricao-dados-pessoais-unico',
                                    ];
                                    const formularioDadosPessoais: any[] = inscricao.formularios.filter((f) => {
                                        return formulariosDadosPessoaisEsp.indexOf(f.formulario_parametrizado.tipo.sigla) > -1;
                                    });
                                    if (formularioDadosPessoais.length > 0) {
                                        this.router.navigate(['/inscricao', inscricao.proponente.codigo, inscricao.codigo, formularioDadosPessoais[0].formulario_parametrizado.tipo.sigla]);
                                    }
                                },
                                (error: any) => {
                                    this.toastr.error('Erro ao criar uma nova inscrição.');
                                }
                            );
                        } else {
                            this.exibirMensagem = true;
                            this.mensagem = this.localStorageService.get('mensagemErroIniciarInscricao');
                            this.carregarDashboard();
                        }
                        
                    } else {
                        this.carregarDashboard();
                    }
                },
                (e: any) => this.toastr.error('Não foi possivel recuperar as parametrizações ativas.')
            );
        } else {
            this.carregarDashboard();
        }
    }

}
